var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.153 0.791949L8.00098 7.94395L0.848977 0.791949C0.752977 0.695949 0.635643 0.647949 0.496977 0.647949C0.35831 0.647949 0.240977 0.695949 0.144977 0.791949C0.0489766 0.887949 0.000976562 1.00528 0.000976562 1.14395C0.000976562 1.28262 0.0489766 1.39995 0.144977 1.49595L8.00098 9.35195L15.857 1.49595C15.953 1.39995 16.001 1.28262 16.001 1.14395C16.001 1.00528 15.953 0.887949 15.857 0.791949C15.761 0.695949 15.6436 0.647949 15.505 0.647949C15.3663 0.647949 15.249 0.695949 15.153 0.791949Z",
    fill: "#415385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDown);
export default __webpack_public_path__ + "static/media/FilterDown.b21c64fae193255e007739816030f40b.svg";
export { ForwardRef as ReactComponent };